// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "../../common/ChoiceGroupLayout/ChoiceGroupLayout"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("../../common/ChoiceGroupLayout/ChoiceGroupLayout"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.ChoiceGroupLayout);
    global.RadioGroup = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _ChoiceGroupLayout) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.useRadioGroup = _exports.RadioGroup = void 0;
  _react = _interopRequireWildcard(_react);
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  var RadioGroupContext = /*#__PURE__*/(0, _react.createContext)(null);
  var useRadioGroup = _exports.useRadioGroup = function useRadioGroup() {
    var context = (0, _react.useContext)(RadioGroupContext);
    return context;
  };
  var RadioGroup = _exports.RadioGroup = function RadioGroup(_ref) {
    var label = _ref.label,
      description = _ref.description,
      error = _ref.error,
      helperText = _ref.helperText,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? _ChoiceGroupLayout.ChoiceGroupDirection.VERTICAL : _ref$direction,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? _ChoiceGroupLayout.ChoiceGroupColumns.SingleCol : _ref$layout,
      value = _ref.value,
      onChange = _ref.onChange,
      children = _ref.children,
      className = _ref.className,
      tooltipProps = _ref.tooltipProps;
    return /*#__PURE__*/_react["default"].createElement(RadioGroupContext.Provider, {
      value: {
        value: value,
        onChange: onChange
      }
    }, /*#__PURE__*/_react["default"].createElement(_ChoiceGroupLayout.ChoiceGroupLayout, {
      label: label,
      description: description,
      error: error,
      helperText: helperText,
      tooltipProps: tooltipProps,
      className: className,
      direction: direction,
      layout: layout
    }, children));
  };
});
